( function( $ ) {
    /*anim init*/
    AOS.init();
    /*anim init*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });

    $('.js-hMenuBtn').click(function() {
        $(this).toggleClass('active');
        $('.js-hMenu').toggleClass('active');
    });

    $('.h-menu ul li.menu-item-has-children').click(function(e){
        $(this).find('.sub-menu').slideToggle();
        $(this).toggleClass('active');
        e.stopPropagation();
    })
    $('.h-menu ul li a').click(function(e){
        $('.js-hMenu').removeClass('active');
        $('.js-hMenuBtn').removeClass('active');
    })
    /*header*/

    /*video play*/
    $('.js-firstPlay').click(function(){
        $(this).addClass('hidden');
        $('.js-firstPlayImg').addClass('hidden');
        $('.js-firstPlayVid').trigger('play');
    });
    /*video play*/

    /*videos tech play*/
    $('.js-techPlay').click(function(){
        $(this).addClass('hidden');
        console.log($(this).siblings('.js-techPlayVid')[0]);
        console.log($(this).siblings('.js-techPlayVid')[0].contentWindow);
        $(this).siblings('.js-techPlayVid')[0].contentWindow.postMessage('{"method":"play"}', '*');
    });
    // $('.js-techPlay').click(function(){
    //     $(this).addClass('hidden');
    //     $(this).siblings('.js-techPlayVid').trigger('play');
    //     techStartPlay($())
    // });

    // function techStartPlay(_this) {
    //     player.getVolume().then(function (volume) {
    //         _this.find('.sound').removeClass('active');
    //         if (volume > 0) {
    //             player.setVolume(0);
    //             _this.find('.sound[data-sound="disabled"]').addClass('active');
    //         } else {
    //             player.setVolume(1);
    //             _this.find('.sound[data-sound="enabled"]').addClass('active');
    //         }
    //     });
    // }
    /*videos tech play*/

    /*vimeo sound*/
    $(document).ready(function () {
        var heroMedia = $('#vimeo-player')[0];
        if (!heroMedia) {
            return;
        }
        if (heroMedia.tagName === 'VIDEO') {
            // direct MP4 background video
            heroMedia.muted = true;
            $('.js-firstLoud').on('click', function () {
                var _this = $(this);
                _this.find('.sound').removeClass('active');
                if (heroMedia.muted) {
                    heroMedia.muted = false;
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                } else {
                    heroMedia.muted = true;
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                }
            });
        } else if (typeof Vimeo !== 'undefined') {
            var player = new Vimeo.Player(heroMedia);
            player.getVolume().then(function (volume) {
                player.setVolume(0);
            });

            function toggleSound(_this) {
                player.getVolume().then(function (volume) {
                    _this.find('.sound').removeClass('active');
                    if (volume > 0) {
                        player.setVolume(0);
                        _this.find('.sound[data-sound="disabled"]').addClass('active');
                    } else {
                        player.setVolume(1);
                        _this.find('.sound[data-sound="enabled"]').addClass('active');
                    }
                });
            }

            $('.js-firstLoud').on('click', function () {
                toggleSound($(this));
            });
        }
    });
    /*vimeo sound*/

    /*widget*/
    $('.js-widgToolsBl').click(function(){
        if ($(window).width() <= 991) {
            if ($(this).hasClass('clicked')) {
                $(this).removeClass('clicked');
            } else {
                $('.js-widgToolsBl').removeClass('clicked');
                $(this).addClass('clicked');
            }
        }
    });

    $('body').on('mousedown', function(e){
        if ($(window).width() <= 991) {
            if (!e.target.classList.contains('js-widgToolsBl') && !e.target.closest('.js-widgToolsBl')) {
                $('.js-widgToolsBl').removeClass('clicked');
            }
        }
    });

    /*widget*/

    /*fader*/
    faderWork($('.js-mainBackFader[data-id="1"]'));
    faderWork($('.js-mainBackFader[data-id="2"]'));
    faderWork($('.js-mainBackFader[data-id="3"]'));
    function faderWork(fader) {
        setInterval(function(){
            var next = fader.find('.active').data('fader') + 1;
            if (fader.find('[data-fader="'+next+'"]').length <= 0)
                next = 0;

            fader.find('img').removeClass('active');
            fader.find('[data-fader="'+next+'"]').addClass('active');
        }, 5000)
    }
    /*fader*/

    /*float placeholders*/
    $('body').click(function(){
        $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
            if ($(this).val() === '')
                $(this).closest('.wpcf7-form-control-wrap').removeClass('active');

        });
    })
    $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').click(function(){
        var _this = $(this);
        setTimeout(function(){
            $('input[type="text"], textarea, input[type="email"], input[type="number"], input[type="tel"]').each(function(el){
                if ($(this).val() === '')
                    $(this).closest('.wpcf7-form-control-wrap').removeClass('active');

            });
            _this.closest('.wpcf7-form-control-wrap').addClass('active');
        }, 5)
    })
    /*float placeholders*/

    /*tratament slider (mobile only)*/
    $(document).ready(function(){
        var traitSlideAll = $('.main-traitements-slide-bl').length;
        if (traitSlideAll > 0 && $(window).width() <= 768) {
            var traitSlideNum = 0;
            $('.js-mainTraitementsSlider').mCustomScrollbar({
                axis:"x",
                callbacks:{
                    onScroll:function(){
                        var sliderOffset = $('.js-mainTraitementsSlider').offset().left;
                        traitSlideNum = mainTraitSliderFindSlide(sliderOffset, 0);
                    }
                }
            });
            $('.js-mainTraitementsSliderPrev').click(function(){
                if (traitSlideNum !== 0) {
                    traitSlideNum--;
                    $('.js-mainTraitementsSlider').mCustomScrollbar('scrollTo',$('.js-mainTraitementsSlider').find('.mCSB_container').find('.main-traitements-slide-bl:eq('+traitSlideNum+')'));
                }
            })
            $('.js-mainTraitementsSliderNext').click(function(){
                if (traitSlideNum < traitSlideAll) {
                    traitSlideNum++;
                    $('.js-mainTraitementsSlider').mCustomScrollbar('scrollTo',$('.js-mainTraitementsSlider').find('.mCSB_container').find('.main-traitements-slide-bl:eq('+traitSlideNum+')'));
                }
            })

            function mainTraitSliderFindSlide(sliderOffset, index) {
                if ($('.js-mainTraitementsSlider').find('.mCSB_container').find('.main-traitements-slide-bl:eq('+index+')').length > 0) {
                    if ($('.js-mainTraitementsSlider').find('.mCSB_container').find('.main-traitements-slide-bl:eq('+index+')').offset().left - sliderOffset >= 0) {
                        return index;
                    } else {
                        return mainTraitSliderFindSlide(sliderOffset, index+1);
                    }
                } else {
                    return index;
                }
            }
        }
    });
    /*tratament slider (mobile only)*/

    /*devices image worker*/
    $('.js-mainDevicesImgChange').on('mouseover', function(){
        $('.js-mainDevicesImg img').attr('src', $(this).data('img'));
    });

    $('.js-mainDevicesHidSlide').on('mouseover', function(){
        if ($(window).width() >=992) {
            $(this).find('.js-mainDevicesHidSlideWrap').stop(true, true).slideDown();
        }
    });
    $('.js-mainDevicesHidSlide').on('mouseleave', function(){
        if ($(window).width() >=992) {
            $(this).find('.js-mainDevicesHidSlideWrap').stop(true, true).slideUp();
        }
    });
    /*devices image worker*/

    /*cliniques filter*/
    $('.js-catClinTerms').click(function(){
        $('.js-catClinTerms').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('categ') === 'all') {
            $('.js-catClinPosts').addClass('active')
        } else {
            $('.js-catClinPosts').removeClass('active')
            $('.js-catClinPosts[data-categ="' + $(this).data('categ') + '"]').addClass('active')
        }
    })
    /*cliniques filter*/

    /*cliniques sliders*/
    $(".js-catClinSlider").on("init reInit afterChange", function(event, slick) {
        $(this).siblings(".js-catClinSliderCount").html(
            slick.slickCurrentSlide() + 1 + "/" + slick.slideCount
        );
    });
    $( '.js-catClinSlider' ).slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        prevArrow: '<button class="arrow prev-arrow"><svg width="52" height="12" viewBox="0 0 52 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M51 6.75C51.4142 6.75 51.75 6.41421 51.75 6C51.75 5.58579 51.4142 5.25 51 5.25L51 6.75ZM0.469669 5.46967C0.176777 5.76257 0.176777 6.23744 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.5962 11.0104 6.5962 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989596 6.3033 0.696703C6.01041 0.40381 5.53553 0.40381 5.24264 0.696703L0.469669 5.46967ZM51 5.25L1 5.25L1 6.75L51 6.75L51 5.25Z" fill="#2C3542"/> </svg></button>"',
        nextArrow: '<button class="arrow next-arrow"><svg width="52" height="12" viewBox="0 0 52 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 6.75C0.585786 6.75 0.25 6.41421 0.25 6C0.25 5.58579 0.585786 5.25 1 5.25L1 6.75ZM51.5303 5.46967C51.8232 5.76257 51.8232 6.23744 51.5303 6.53033L46.7574 11.3033C46.4645 11.5962 45.9896 11.5962 45.6967 11.3033C45.4038 11.0104 45.4038 10.5355 45.6967 10.2426L49.9393 6L45.6967 1.75736C45.4038 1.46447 45.4038 0.989596 45.6967 0.696703C45.9896 0.40381 46.4645 0.40381 46.7574 0.696703L51.5303 5.46967ZM1 5.25L51 5.25L51 6.75L1 6.75L1 5.25Z" fill="#2C3542"/> </svg></button>',

    } );
    $(document).ready(function(){
        $('.js-catClinTermsScroll').mCustomScrollbar({
            axis:"x"
        });
    });
    /*cliniques sliders*/

    /*main gallery slider*/
    var galSlider = $( '.js-gallerySlider' ).slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        prevArrow: '<button class="arrow prev-arrow"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.5 10L1 5.5L5.5 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>"',
        nextArrow: '<button class="arrow next-arrow"><svg width="50" height="11" viewBox="0 0 50 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 5.5H40.5" stroke="white" stroke-linecap="round"/> <path d="M44.5 10L49 5.5L44.5 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',

    } );
    $(".js-gallerySlider").on("init reInit afterChange", function(event, slick) {
        $(this).siblings(".js-gallerySliderCount").html(
            slick.slickCurrentSlide() + 1 + " / " + slick.slideCount
        );
    });
    $('.js-gallerySliderPos').click(function(){
        galSlider.slick('slickGoTo', $(this).data('gal_num'));
    })
    /*main gallery slider*/

    /*modal*/
        $('.js-modalOpen').click(function(e){
            e.preventDefault();
            $('.js-modal[data-modal="'+$(this).data('modal')+'"]').addClass('active');
        });
        $('.js-modalClose').click(function(){
            $(this).closest('.js-modal').removeClass('active');
        });
    /*modal*/

    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*team gallery sliders*/
    $(".js-pageDentSliderBig").on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var allSlides = Math.ceil(slick.slideCount / cnt);
        // the template renders every photo twice for the infinite loop -
        // count and number only the real photos
        if (allSlides > 1) {
            allSlides = allSlides / 2;
        }
        var slideNum = 1;
        if (nextSlide !== undefined) {
            slideNum = (nextSlide % allSlides) + 1;
        }
        $(".js-pageDentSliderBigCount").html(
            slideNum + " / " + allSlides
        );
    });
    $( '.js-pageDentSliderBig' ).slick( {
        fade: false,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        draggable: false,
        variableWidth: false,
        autoplay: false,
        prevArrow: '<button class="arrow prev-arrow"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.5 10L1 5.5L5.5 1" stroke="#2C3542" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>"',
        nextArrow: '<button class="arrow next-arrow"><svg width="50" height="11" viewBox="0 0 50 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 5.5H40.5" stroke="#2C3542" stroke-linecap="round"/> <path d="M44.5 10L49 5.5L44.5 1" stroke="#2C3542" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
        appendArrows: $('.js-pageDentSliderBigArrows')

    } );
    $( '.js-pageDentSlider' ).slick( {
        fade: false,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        draggable: false,
        centerMode: false,
        variableWidth: false,
        autoplay: false,// asNavFor: '.js-pageDentSliderBig',
        prevArrow: '<button class="arrow prev-arrow"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.5 10L1 5.5L5.5 1" stroke="#2C3542" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>"',
        nextArrow: '<button class="arrow next-arrow"><svg width="50" height="11" viewBox="0 0 50 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 5.5H40.5" stroke="#2C3542" stroke-linecap="round"/> <path d="M44.5 10L49 5.5L44.5 1" stroke="#2C3542" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
    } );
    // Thumbnails track runs 3 positions behind the big slider, so with
    // thumbs [0.5A, B, C] the big one shows D (rightmost full thumb + 1):
    // next -> thumbs [0.5B, C, D], big E; prev -> thumbs [0.5Ж, A, B], big C.
    // The big photo is never duplicated among the visible thumbs.
    if ($(window).width() > 767) {
        var pdsThumbs = $(".js-pageDentSlider");
        pdsThumbs.slick("slickGoTo", pdsThumbs.slick("getSlick").slideCount - 3, true);
    }
    $('.js-pageDentSliderBig').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var slide_count = slick.slideCount - 1;
        var is_cur_first = currentSlide === 0;
        var is_next_last = nextSlide === slide_count;
        var is_prev_break_point = is_cur_first && is_next_last;
        if ((currentSlide < nextSlide && !is_prev_break_point) || (currentSlide === slide_count && nextSlide === 0)) {
            $(".js-pageDentSlider").slick("slickNext");
        }
        else if (currentSlide > nextSlide || (currentSlide === 0 && nextSlide === slide_count)) {
            $(".js-pageDentSlider").slick("slickPrev");
        }
    });

    /*team gallery sliders*/

}( jQuery ) );
